import { Helmet } from 'react-helmet-async';
import AccountPerformance from 'src/sections/overview/dashboards/views/campaign-leaks/account-performance';

export default function CampaignLeaksAccountPerformance() {
  return (
    <>
      <Helmet>
        <title>Campaign Leaks · Account Performance</title>
      </Helmet>

      <AccountPerformance />
    </>
  );
}
